const EXPIRY_KEY = 'localStorageExpiry';
const EXPIRY_DURATION = 1000 * 60 * 60 * 24; // 1 day

function updateExpiry() {
  localStorage.setItem(EXPIRY_KEY, Date.now().toString());
}

function checkExpiry() {
  const now = Date.now();
  const expiry = localStorage.getItem(EXPIRY_KEY);

  if (expiry && now - parseInt(expiry, 10) > EXPIRY_DURATION) {
    localStorage.clear();
    console.log('localStorage expired due to inactivity and was cleared.');
  }
}

// --- Run expiry check when page loads ---
checkExpiry();

// --- Update expiry on user activity ---
['click', 'mousemove', 'keydown', 'scroll', 'touchstart'].forEach(evt => {
  window.addEventListener(evt, updateExpiry);
});
// // ===============================
// // Load Country Code BEFORE Vue starts
// // ===============================
function loadCountryCode() {
  return new Promise((resolve) => {
    const oldRegion = localStorage.getItem("region");

    // Always fetch new region
    fetch("https://ipapi.co/country/")
      .then(res => res.text())
      .then(newRegion => {
        console.log("Fetched Region:", newRegion);

        // Normalize whitespace or weird values
        newRegion = newRegion.trim();

        // If new region differs from stored region → update
        if (newRegion && newRegion !== oldRegion) {
          console.log("Region updated:", oldRegion, "→", newRegion);
          localStorage.setItem("region", newRegion);
        }

        resolve(newRegion);
      })
      .catch(err => {
        console.error("Country fetch error:", err);
        resolve(oldRegion); // fallback to existing region
      });
  });
}

// const TESTING_IPS = ['110.39.156.90', '202.141.226.196','12.79.177.118'];
// let currentUserIP = null;  // We'll store the real IP here

// async function loadCountryCode() {
//   return new Promise(async (resolve) => {
//     const oldRegion = localStorage.getItem("region");

//     try {
//       // First, get the real IP (we need this for testing IPs)
//       const ipResponse = await fetch('https://api.ipify.org?format=json');
//       const ipData = await ipResponse.json();
//       currentUserIP = ipData.ip;
//       console.log("Detected IP:", currentUserIP);

//       // CHECK IF USER IS ON TESTING IP
//       if (TESTING_IPS.includes(currentUserIP)) {
//         console.log("TESTING IP DETECTED → Bypassing ALL protection!");
//         localStorage.setItem("region", "US");                    // Fake as USA
//         localStorage.setItem("isAuthenticatedToAccessWebsite", "true"); // Full access
//         resolve("US");
//         return;
//       }

//       // Normal flow: fetch country
//       const res = await fetch("https://ipapi.co/country/");
//       let newRegion = await res.text();
//       newRegion = newRegion.trim();

//       if (newRegion && newRegion !== oldRegion) {
//         localStorage.setItem("region", newRegion);
//       }

//       resolve(newRegion || oldRegion || "US");
//     } catch (err) {
//       console.error("IP/Country fetch failed:", err);
//       resolve(oldRegion || "US");
//     }
//   });
// }

import Vue from 'vue'
import App from './App.vue'
import router from './router'
import BootstrapVue from 'bootstrap-vue'
import VueSnotify from 'vue-snotify'
import VueSweetalert2 from 'vue-sweetalert2'
import VueGoodTablePlugin from 'vue-good-table';
import 'vue-good-table/dist/vue-good-table.css'
import vSelect from 'vue-select'
import './session'
import 'vue-select/dist/vue-select.css';
import InputColorPicker from "vue-native-color-picker";
import 'vue2-daterange-picker/dist/vue2-daterange-picker.css';
import ToggleButton from 'vue-js-toggle-button'
import store from './store'
Vue.prototype.$server_url = 'https://www.vanovy.com/';
Vue.prototype.$EventBus = new Vue();
import VueLoadmore from 'vuejs-loadmore';
import VueI18n from 'vue-i18n'
import messages from '../src/languages/languages.json';
import VueAxios from 'vue-axios'
import VueSocialauth from "vue-social-auth";
import axios from 'axios'
import 'vue-loaders/dist/vue-loaders.css';
import VueLoaders from 'vue-loaders';
import VueHead from 'vue-head';
import vueTelInput from 'vue-tel-input';
import 'vue-tel-input/dist/vue-tel-input.css'

const OAUTH_CALLBACK_PATHS = ['/login/google/callback', '/auth/facebook/callback'];

function isOAuthCallbackRoute() {
  return OAUTH_CALLBACK_PATHS.some((path) => window.location.pathname.startsWith(path));
}


Vue.use(VueLoadmore, {
  lang: 'en-US'
});
Vue.use(VueHead);
Vue.use(vueTelInput)
Vue.use(VueAxios, axios)
Vue.use(VueSocialauth, {
  providers: {
    facebook: {
      // clientId: "1981433512311522",
      clientId: "1532935714336326",
      // redirectUri: "http://localhost:8080/auth/facebook/callback",
      redirectUri: "https://www.vanovy.com/auth/facebook/callback",
    },
    google: {
      clientId: "788888898566-k87c2o8222f3c6ig66vqtsvsild3n6pl.apps.googleusercontent.com",
      // redirectUri: "http://localhost:8080/login/google/callback",
      redirectUri: "https://www.vanovy.com/login/google/callback",
    },
  },
});
Vue.use(ToggleButton)
Vue.use(VueLoaders);
Vue.use(VueSnotify)
Vue.use(InputColorPicker);
Vue.use(BootstrapVue)
Vue.use(VueSweetalert2)
Vue.use(VueI18n)
Vue.use(router)
Vue.use(store)
Vue.use(VueGoodTablePlugin);
Vue.config.productionTip = false
Vue.component('v-select', vSelect)

const SUPPORTED_LANGUAGES = ['en', 'es', 'de', 'fr', 'nl', 'cn', 'es-ar', 'es-mx', 'ca', 'it', 'ar'];
const savedLocaleRaw = localStorage.getItem('language');

// Always default to English unless user selected a supported language
const savedLocale = (savedLocaleRaw && SUPPORTED_LANGUAGES.includes(savedLocaleRaw))
  ? savedLocaleRaw
  : 'en';

const i18n = new VueI18n({
  locale: savedLocale,
  fallbackLocale: 'en',
  messages,
});

// Manual language switch ONLY
Vue.prototype.$EventBus.$on('changeLanguage', (language) => {
  const validLang = SUPPORTED_LANGUAGES.includes(language) ? language : 'en';
  i18n.locale = validLang;
  localStorage.setItem('language', validLang);
});

// new Vue({
//   router,
//   store,
//   i18n,
//   render: h => h(App)
// }).$mount('#app')

// ===============================================
// START VUE — skip ipapi fetch on OAuth callback popups
// ===============================================
function bootstrapApp() {
  new Vue({
    router,
    store,
    i18n,
    render: h => h(App)
  }).$mount('#app');
}

if (isOAuthCallbackRoute()) {
  bootstrapApp();
} else {
  loadCountryCode().then(bootstrapApp);
}
